export let DistributionType = /*#__PURE__*/function (DistributionType) {
  DistributionType["Giveaway"] = "giveaway";
  DistributionType["Shipout"] = "shipout";
  DistributionType["PFI"] = "pull_from_inventory";
  return DistributionType;
}({});
export let ReceiverPartType = /*#__PURE__*/function (ReceiverPartType) {
  ReceiverPartType["Tracking"] = "tracking";
  ReceiverPartType["WarehouseShipmentNumber"] = "warehouseShipmentNumber";
  ReceiverPartType["Address"] = "address";
  return ReceiverPartType;
}({});
export let CustomFilterType = /*#__PURE__*/function (CustomFilterType) {
  CustomFilterType["Backorder"] = "Backorder";
  CustomFilterType["Error"] = "Error";
  CustomFilterType["Unfulfillable"] = "Unfulfillable";
  return CustomFilterType;
}({});